import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import StaticPage from '../../containers/StaticPage/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import FAQPageAccordionGeneral from './FAQPageAccordionGeneral';
import FAQPageAccordionForTeachers from './FAQPageAccordionForTeachers';
import FAQPageAccordionForAdmins from './FAQPageAccordionForAdmins';
import FAQPageAccordionForFamilies from './FAQPageAccordionForFamilies';

import css from './FAQPage.module.css';
import {compose} from "redux";
import {injectIntl} from "../../util/reactIntl";
import {ListingPageComponent} from "../ListingPage/ListingPageHeroImage";

const FAQPageComponent = (props) => {

  const [activeTab, setActiveTab] = useState("general")

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0)
    }
    if(props?.location?.hash === '#general') setActiveTab("general")
    if(props?.location?.hash === '#teachers') setActiveTab("forTeachers")
    if(props?.location?.hash === '#admins') setActiveTab("forAdmins")
    if(props?.location?.hash === '#families') setActiveTab("forFamilies")

  }, [])


  return (
    <StaticPage
      title="FAQ"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'FAQPage',
        description: 'FAQ AllCourse',
        name: 'FAQ page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <div className={css.hero}>
            <h1 className={css.heroTitle}>
              Frequently Asked Questions
            </h1>
          </div>

          <div className={css.container}>
            <ul className={css.tabs}>
              <li
                className={classNames(css.tabsItem, { [css.tabItemActive]: activeTab === "general" })}
                onClick={() => {
                  setActiveTab("general");
                  props.history.push('#general')
                }}
              >
                General
              </li>
              <li
                className={classNames(css.tabsItem, { [css.tabItemActive]: activeTab === "forTeachers" })}
                onClick={() => {
                  setActiveTab("forTeachers")
                  props.history.push('#teachers')
                }}
              >
                For Teachers
              </li>
              <li
                className={classNames(css.tabsItem, { [css.tabItemActive]: activeTab === "forAdmins" })}
                onClick={() => {
                  setActiveTab("forAdmins");
                  props.history.push('#admins')
                }}
              >
                For School Administrators
              </li>
              <li
                className={classNames(css.tabsItem, { [css.tabItemActive]: activeTab === "forFamilies" })}
                onClick={() => {
                  setActiveTab("forFamilies");
                  props.history.push('#families')
                }}
              >
                For Families
              </li>
            </ul>

            <div className={css.accordion}>
              {activeTab === "general" && <FAQPageAccordionGeneral key="general" />}
              {activeTab === "forTeachers" && <FAQPageAccordionForTeachers key="forTeachers" />}
              {activeTab === "forAdmins" && <FAQPageAccordionForAdmins key="forAdmins" />}
              {activeTab === "forFamilies" && <FAQPageAccordionForFamilies key="forFamilies" />}
            </div>

          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

const FAQPage = compose(
  withRouter,
  injectIntl
)(FAQPageComponent);

export default FAQPage;
